import React, { useContext, useMemo } from "react";
import { MonthlyTradingReportData } from "../../../data/reports/monthlyTrade/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { Action } from "material-table";
import { useHistory } from "react-router-dom";
//import { useViewBank } from "./DisplayBank";
import {
  getProductLocation,
  getClientLocation,
  getDateLocation,
} from "./Locations";
import EventOutlinedIcon from "@material-ui/icons/EventOutlined";
import PeopleOutlineOutlinedIcon from "@material-ui/icons/PeopleOutlineOutlined";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import { useAuth } from "../../../data/auth/hooks";

export const useMonthlyActions = () => {
  const { getString } = useContext(LocalizationContext);

  const [auth] = useAuth();

  const history = useHistory();

  return useMemo(() => {
    const result: Action<MonthlyTradingReportData>[] = [
      { 
        icon: () => <LocalShippingOutlinedIcon />,
        tooltip: getString("mTableProduct"),
        onClick: (event, rowData) => {
          const reportData = rowData as MonthlyTradingReportData;
          history.push(
            getProductLocation(reportData.year, reportData.yearPart)
          );
        }, 
      },
      {
        icon: () => <PeopleOutlineOutlinedIcon />,
        tooltip: getString("mTableClient"),
        onClick: (event, rowData) => {
          const reportData = rowData as MonthlyTradingReportData;
          history.push(getClientLocation(reportData.year, reportData.yearPart));
        },
        hidden:  auth.status === "successful" && (auth.user.roleCode === "MEMTRADER" || auth.user.roleCode === "MEMMANAGER"  ||  auth.user.roleCode === "MEMCONTACT" )  
      },
      {
        icon: () => <EventOutlinedIcon />,
        tooltip: getString("mTableDate"),
        onClick: (event, rowData) => {
          const reportData = rowData as MonthlyTradingReportData;
          history.push(getDateLocation(reportData.year, reportData.yearPart));
        },
      },
    ];

    return result;
  }, [, , getString]);
};
